import { useDispatch } from "react-redux";
import { addFilter, clearFilter, removeTag } from "../../../store/actions/statisticsFilters";
import Tag from "../../uiComponents/Tag";
import SidebarButtonDropdown from "../SidebarButtonDropdown";
import SidebarDropdown from "../SidebarDropdown";
import React, { useState } from "react";
import './SelectFilterField.scss'

const SelectFilterField = ({
                  isSearch = true,
                  commonOptions,
                  type,
                  dependenceSelect,
                  isClear = true,
                  selectedItems,
                  isTags = true,
                  title,
                  selectLabel,
                  isMultiSelect = true
                }) => {


  const selectTitle = !isMultiSelect && selectedItems?.length > 0 ? selectedItems.join() : title
  const label =  isMultiSelect && selectedItems.length > 0 ? `${selectLabel} ( ${selectedItems.length} )` : selectLabel


  const dispatch = useDispatch();


  const [isOpenInitialDropdown, setIsOpenInitialDropdown] = useState(false);

  const onOpenCallback = (value) => {
    setIsOpenInitialDropdown(value)
  }


  const clearSelectHandler = () => {
    dispatch(clearFilter(type));
    onOpenCallback(false)
  };

  const onChangeSelectedItems = (value) => {
    dispatch(clearFilter(dependenceSelect))
    dispatch(addFilter(value, type, isMultiSelect));
    if (!isMultiSelect) {
      onOpenCallback(false)
    }
  };

  const onRemoveTagHandler = (value) => {
    dispatch(removeTag(value, type));
  };


  const renderTags = (dataArray) => {
    if (dataArray?.length === 0) {
      return;
    }
    return (
      <div className={"sidebar-module__select__tags"}>
        {dataArray.map((tag, index) => {
          return <Tag key={index} title={tag} onRemoveTag={(value) => onRemoveTagHandler(value, type)} />;
        })}
      </div>
    );
  };

  return (
    <div className={"sidebar-module__select__wrapper"}>
      <SidebarButtonDropdown
        onOpenCallback={onOpenCallback}
        label={label}
        buttonTitle={selectTitle}
        isClear={isClear}
        clearActive={selectedItems?.length > 0}
        onClearAll={clearSelectHandler}
        isOpenInitialDropdown={isOpenInitialDropdown}
        disabled={commonOptions.length <= 0}
        dropdownPosition={"right"}>
        <SidebarDropdown
          doubleColumns={commonOptions.length >= 10}
          optionsType={type}
          isSearch={isSearch}
          isMultiSelect={isMultiSelect}
          selectedItems={selectedItems}
          onChangeSelectedItems={(option, optionsType) => onChangeSelectedItems(option, optionsType)}
          commonOptions={commonOptions} />
      </SidebarButtonDropdown>
      {isTags && renderTags(selectedItems)}
    </div>
  );
};

export default SelectFilterField;
